import React, { useState } from 'react';

import { Col, Drawer, Row } from 'antd';

import { useShipment } from '@/features/securityCheck/api/getShipment';
import { InspectionClosure } from '@/features/securityCheck/components/InspectionClosure';
import { InspectionSession } from '@/features/securityCheck/components/InspectionSession';
import { ShipmentCardStatic } from '@/features/securityCheck/components/ShipmentCardStatic';
import { useInspectionTicketView } from '@/features/securityCheck/hooks/useInspectionTicketView';
import { useInspectionStore } from '@/features/securityCheck/store/inspection.store';

export const SecurityInspection = ({
  open,
  onClose,
  lpui,
}: {
  open: boolean;
  onClose: () => void;
  lpui: string;
}) => {
  const [isSummaryVisible, setIsSummaryVisible] = useState(false);

  const ticket = useInspectionStore((state) => state.ticket);
  const isSessionActive = useInspectionStore((state) => state.isSessionActive);
  const isInspectionOrSummaryActive = isSessionActive || isSummaryVisible;

  const setSessionActive = useInspectionStore(
    (state) => state.setSessionActive
  );

  const shipmentResponse = useShipment({
    criterias: { lpui },
    config: {
      refetchOnWindowFocus: false,
      enabled: true,
    },
  });

  const shipment = shipmentResponse?.data?.[0] ?? {};

  const { startInspection } = useInspectionTicketView();
  const handleResetInspection = () => {
    setSessionActive(false);
    setIsSummaryVisible(false);
  };

  const handleStartInspection = (shipment) => {
    if (shipment) {
      handleResetInspection();
      startInspection({
        currentTicketId: shipment?.current_ticket_id || '',
        currentTicketStartDate: shipment?.current_ticket_start_date || '',
        lpUi: lpui,
        inspectionInProgress: shipment?.inspection_in_progress,
        shipmentId: shipment?.shipment_id,
      });
      setSessionActive(true);
    }
  };

  const handleEndInspection = () => {
    setSessionActive(false);
    setIsSummaryVisible(true);
  };

  const handleCloseInspection = () => {
    handleResetInspection();
    onClose();
  };

  return (
    <Drawer
      title="Security Inspection"
      placement="right"
      open={open}
      onClose={onClose}
      width="90%"
      styles={{
        content: {
          marginTop: '70px',
          borderTopLeftRadius: '10px',
        },
      }}
    >
      <Row gutter={[16, 16]}>
        <Col
          xs={24}
          sm={24}
          md={isInspectionOrSummaryActive ? 10 : 24}
          lg={isInspectionOrSummaryActive ? 8 : 24}
          xl={isInspectionOrSummaryActive ? 7 : 24}
        >
          <ShipmentCardStatic
            shipment={shipment}
            onStartInspection={() => {
              handleStartInspection(shipment);
            }}
            inspectionInProgress={isInspectionOrSummaryActive}
          />
        </Col>
        {isSummaryVisible && (
          <Col xs={24} sm={24} md={14} lg={16} xl={17}>
            <InspectionClosure
              inspectionTicketId={ticket ?? ''}
              updateStep={() => handleCloseInspection()}
            />
          </Col>
        )}
        {isSessionActive && (
          <Col xs={24} sm={24} md={14} lg={16} xl={17}>
            <InspectionSession
              shipment={shipment}
              isInspectionStarted={isSessionActive}
              onEndInspection={handleEndInspection}
            />
          </Col>
        )}
      </Row>
    </Drawer>
  );
};
